import { useEffect, useRef, useState } from 'react';

import { isMotionReduced } from 'src/app/shared/utils/accessibility';

import { findScrollTargets } from '../../utils';

export function useShareFeed(intervalSeconds: number, itemCount: number) {
	const [prefersReducedMotion] = useState(() => isMotionReduced());
	const scrollerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const scroller = scrollerRef.current;
		if (!(scroller && !prefersReducedMotion && itemCount > 0)) {
			return undefined;
		}

		const handleInterval = () => {
			const firstChild = scroller.children[0] as HTMLElement | undefined;
			const firstOfSecondCopy = scroller.children[itemCount] as HTMLElement | undefined;

			if (firstChild && firstOfSecondCopy) {
				const resetThreshold = firstOfSecondCopy.offsetLeft - firstChild.offsetLeft;
				const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
				// Subtract 1 to account for sub-pixel rounding in browser scroll calculations
				const atEnd = maxScrollLeft > 0 && scroller.scrollLeft >= maxScrollLeft - 1;
				if (scroller.scrollLeft >= resetThreshold || atEnd) {
					// Temporarily disable scroll-smooth so the reset is instant (not animated backwards)
					scroller.style.scrollBehavior = 'auto';
					scroller.scrollLeft = 0;
					scroller.style.scrollBehavior = '';
				}
			}

			const { next } = findScrollTargets(scroller);
			if (next) {
				scroller.scroll({ left: next.offsetLeft });
			}
		};

		const intervalId = setInterval(handleInterval, intervalSeconds * 1_000);
		return () => clearInterval(intervalId);
	}, [intervalSeconds, itemCount, prefersReducedMotion]);

	return scrollerRef;
}
